import React from 'react';
import {
    StyledContainer,
    StyledIconContainer,
    StyledLabel,
    StyledAmount,
} from './label-icon.style';
import { theme } from '../../../style/global-style';

import YearBuildSvg from '../../../../public/static/icons/yearbuilt.svg';
import UserGroupSvg from '../../../../public/static/icons/user_group.svg';
import CrewSvg from '../../../../public/static/icons/crew.svg';
import ShipWaterSvg from '../../../../public/static/icons/ship.svg';
import DecksSvg from '../../../../public/static/icons/deck.svg';
import CalendarSvg from '../../../../public/static/icons/calendar.svg';
import TourSvg from '../../../../public/static/icons/tour.svg';
import HabourSvg from '../../../../public/static/icons/anchor.svg';
import EarthSvg from '../../../../public/static/icons/earth.svg';
import BordLanguage from '../../../../public/static/icons/bord-language.svg';
import { ITranslationKeys } from '../../../../../interfaces';
import { __ } from '../../../utils/translation-service';

export interface ILabelIconProps {
    type:
        | 'buildYear'
        | 'passenger'
        | 'crew'
        | 'decks'
        | 'ship'
        | 'language'
        | 'newestShip'
        | 'destinations'
        | 'harbours'
        | 'routes'
        | 'length'
        | 'travelWindow';
    amount: string;
    iconColor?: string;
    fontColor?: string;
    horizontal?: boolean;
}

export const LabelIcon: React.FunctionComponent<ILabelIconProps> = ({
    type,
    amount,
    iconColor = theme.colors.main4,
    fontColor = theme.shades.blackGrey,
    horizontal = false,
}: ILabelIconProps) => {
    const IconComponent = {
        // ship page
        buildYear: { icon: <YearBuildSvg />, label: 'shipLaunchDate' },
        passenger: { icon: <UserGroupSvg />, label: 'shipPassengers' },
        crew: { icon: <CrewSvg />, label: 'shipCrew' },
        decks: { icon: <DecksSvg />, label: 'shipDecks' },
        // Cruiseline page
        ship: { icon: <ShipWaterSvg />, label: 'cruiselineShips' },
        language: { icon: <BordLanguage />, label: 'cruiselineBoardLanguage' },
        newestShip: { icon: <YearBuildSvg />, label: 'cruiselineNewestShip' },
        destinations: { icon: <EarthSvg />, label: 'cruiselineDestinations' },
        //destination page
        harbours: { icon: <HabourSvg />, label: 'destinationHarbours' },
        routes: { icon: <TourSvg />, label: 'destinationRoutes' },
        travelWindow: { icon: <CalendarSvg />, label: 'travelWindow' },

        length: { icon: <ShipWaterSvg />, label: 'shipLength' },
    };
    return (
        <StyledContainer horizontal={horizontal} data-testid={'label-icon-component'}>
            <StyledIconContainer iconColor={iconColor} horizontal={horizontal}>
                {IconComponent[type].icon}
            </StyledIconContainer>
            <StyledAmount horizontal={horizontal} fontColor={fontColor} iconType={type}>
                {amount}
            </StyledAmount>
            <StyledLabel horizontal={horizontal} fontColor={fontColor} iconType={type}>
                {__(IconComponent[type].label as any) as ITranslationKeys}
            </StyledLabel>
        </StyledContainer>
    );
};
